import { Injectable } from '@angular/core';
import { FileService } from './file-service';

@Injectable()
export class LocalFileService implements FileService {
  /* eslint-disable-next-line */
  getFile(bucket: string, path: string): Promise<Blob | null> {
    /* eslint-disable-next-line */
    return new Promise((resolve, reject) => {});
  }

  /* eslint-disable-next-line */
  getAsset(path: string): Promise<Blob | null> {
    /* eslint-disable-next-line */
    return new Promise((resolve, reject) => {});
  }

  /* eslint-disable-next-line */
  getUrl(bucket: string, path: string): Promise<string | null> {
    /* eslint-disable-next-line */
    return new Promise((resolve, reject) => {});
  }
}
